/*
  groom.bg mega menu (snippets/groom-mega.liquid, one panel per world after its category bar).
  Desktop with a mouse (≥990 px, hover): hovering a category pill opens the panel at that
  department; the rail on the left switches departments; the pill itself still links to the
  category page. "Всички категории" toggles the panel. Leaving the bar + panel closes it.
  Touch or narrower screens: tapping a pill opens that department as a bottom sheet (the
  "Всичко в …" link inside goes to the page); columns fold, the first one open.
  Escape, the scrim and ✕ close it. Code buttons ([data-groom-copy]) copy the discount code.
*/
(() => {
  const T = window.groomT || {};
  const t = (k, fb) => T[k] || fb;
  const wide = window.matchMedia('(min-width: 990px) and (hover: hover)');
  let open = null; // { mega, nav, pane }
  let hoverTimer = 0;
  let leaveTimer = 0;

  const megaFor = (el) => {
    const nav = el.closest('[data-mega-nav]');
    return nav ? document.getElementById(`g-mega-${nav.dataset.megaNav}`) : el.closest('.g-mega');
  };
  const navFor = (mega) => document.querySelector(`[data-mega-nav="${mega.dataset.megaWorld}"]`);
  // "Всички категории" opens where the shopper last was, else on the first department
  const startPane = (mega) => {
    if (mega.dataset.lastPane) return mega.dataset.lastPane;
    const first = mega.querySelector('.g-mega__pane:not([data-pane="offers"])');
    return first ? first.dataset.pane : '';
  };

  function setExpanded(nav, pane) {
    if (!nav) return;
    nav.querySelectorAll('[data-mega]').forEach((a) => a.setAttribute('aria-expanded', String(a.dataset.mega === pane)));
    const all = nav.querySelector('[data-mega-all]');
    if (all) all.setAttribute('aria-expanded', String(!!pane));
  }

  function showPane(mega, pane) {
    const panes = mega.querySelectorAll('.g-mega__pane');
    let target = mega.querySelector(`.g-mega__pane[data-pane="${pane}"]`) || panes[0];
    if (!target) return null;
    panes.forEach((p) => { p.hidden = p !== target; });
    mega.querySelectorAll('[data-mega-pane]').forEach((b) => b.setAttribute('aria-current', String(b.dataset.megaPane === target.dataset.pane)));
    const title = mega.querySelector('[data-mega-title]');
    if (title) title.textContent = target.dataset.title || t('mega_categories', 'Категории');
    if (!wide.matches) {
      target.querySelectorAll('details.g-mega__col').forEach((d, i) => { d.open = i === 0; });
    } else {
      target.querySelectorAll('details.g-mega__col').forEach((d) => { d.open = true; });
    }
    return target.dataset.pane;
  }

  // The bar is its own stacking layer (under the phone tab bar), so the sheet lives on <body>
  // while it is a sheet, and goes back under the bar for the desktop panel.
  const homes = new Map();
  function place(mega, sheet) {
    if (!homes.has(mega)) homes.set(mega, mega.parentElement);
    const home = homes.get(mega);
    if (sheet && mega.parentElement !== document.body) document.body.appendChild(mega);
    else if (!sheet && home && mega.parentElement !== home) home.appendChild(mega);
  }

  function openMega(mega, pane) {
    if (open && open.mega !== mega) closeMega();
    clearTimeout(leaveTimer);
    const shown = showPane(mega, pane);
    if (!shown) return;
    place(mega, !wide.matches);
    mega.hidden = false;
    mega.classList.toggle('is-sheet', !wide.matches);
    document.documentElement.classList.toggle('g-mega-lock', !wide.matches);
    const nav = navFor(mega);
    setExpanded(nav, shown);
    open = { mega, nav, pane: shown };
  }

  function closeMega() {
    clearTimeout(hoverTimer);
    clearTimeout(leaveTimer);
    if (!open) return;
    open.mega.hidden = true;
    open.mega.classList.remove('is-sheet');
    setExpanded(open.nav, null);
    document.documentElement.classList.remove('g-mega-lock');
    open = null;
  }

  document.addEventListener('click', (event) => {
    const t = event.target instanceof Element ? event.target : null;
    if (!t) return;

    const copy = t.closest('[data-groom-copy]');
    if (copy) {
      event.preventDefault();
      const code = copy.dataset.groomCopy;
      const label = copy.querySelector('[data-groom-copy-label]');
      const done = () => { if (label) { label.textContent = t('mega_copied', 'копирано ✓'); setTimeout(() => { label.textContent = t('mega_copy', 'копирай'); }, 2000); } };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
      else done();
      return;
    }

    if (t.closest('[data-mega-close]')) { event.preventDefault(); closeMega(); return; }

    const all = t.closest('[data-mega-all]');
    if (all) {
      event.preventDefault();
      const mega = megaFor(all);
      if (!mega) return;
      if (open && open.mega === mega) closeMega();
      else openMega(mega, startPane(mega));
      return;
    }

    const pill = t.closest('[data-mega]');
    if (pill && !wide.matches) {
      // touch: the pill opens the sheet; its page is one tap away inside ("Всичко в …")
      const mega = megaFor(pill);
      if (!mega) return;
      event.preventDefault();
      if (open && open.mega === mega && open.pane === pill.dataset.mega) closeMega();
      else openMega(mega, pill.dataset.mega);
      return;
    }

    const rail = t.closest('[data-mega-pane]');
    if (rail) {
      event.preventDefault();
      const mega = rail.closest('.g-mega');
      mega.dataset.lastPane = rail.dataset.megaPane;
      openMega(mega, rail.dataset.megaPane);
      return;
    }

    if (open && wide.matches && !t.closest('.g-mega, [data-mega-nav]')) closeMega();
  });

  /* desktop hover intent */
  document.addEventListener('pointerover', (event) => {
    if (!wide.matches || event.pointerType === 'touch') return;
    const t = event.target instanceof Element ? event.target : null;
    if (!t) return;
    const pill = t.closest('[data-mega]');
    const rail = t.closest('[data-mega-pane]');
    const all = t.closest('[data-mega-all]');
    const zone = t.closest('.g-dept-row');
    if (zone) clearTimeout(leaveTimer);
    clearTimeout(hoverTimer);
    if (all && !open) {
      const mega = megaFor(all);
      if (mega) hoverTimer = setTimeout(() => openMega(mega, startPane(mega)), 200);
    } else if (pill) {
      const mega = megaFor(pill);
      if (!mega) return;
      hoverTimer = setTimeout(() => { mega.dataset.lastPane = pill.dataset.mega; openMega(mega, pill.dataset.mega); }, open ? 60 : 160);
    } else if (rail && open) {
      hoverTimer = setTimeout(() => { open.mega.dataset.lastPane = rail.dataset.megaPane; openMega(open.mega, rail.dataset.megaPane); }, 90);
    }
  });
  document.addEventListener('pointerout', (event) => {
    if (!wide.matches || !open || event.pointerType === 'touch') return;
    const to = event.relatedTarget instanceof Element ? event.relatedTarget : null;
    if (to && to.closest('.g-dept-row')) return;
    const from = event.target instanceof Element ? event.target : null;
    if (!from || !from.closest('.g-dept-row')) return;
    clearTimeout(hoverTimer);
    leaveTimer = setTimeout(closeMega, 280);
  });

  /* keyboard: Enter / Space on a rail item is a click; Escape closes and returns focus */
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !open) return;
    const nav = open.nav;
    closeMega();
    const back = nav && (nav.querySelector('[data-mega-all]') || nav.querySelector('[data-mega]'));
    if (back) back.focus();
  });

  /* a world switch or a resize across the breakpoint starts clean */
  document.addEventListener('groom:world', closeMega);
  wide.addEventListener('change', closeMega);
})();
